import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api } from "@/lib/api";
import { useAdmin, AdminLoading } from "@/pages/admin/useAdmin";
import { AdminOSList } from "@/pages/admin/AdminOSList";
import { AdminDrList } from "@/pages/admin/AdminDrList";
import { AdminPrices } from "@/pages/admin/AdminPrices";
import { AdminBranding } from "@/pages/admin/AdminBranding";

const TABS = [["os", "Ordens de serviço", AdminOSList], ["dr", "Dr. Ruídos", AdminDrList], ["precos", "Preços", AdminPrices], ["marca", "Identidade visual", AdminBranding]];

export default function AdminDashboard() {
  const user = useAdmin();
  const nav = useNavigate();
  if (!user) return <AdminLoading />;
  const logout = async () => { await api.post("/auth/logout"); nav("/admin/login"); };
  return (
    <section className="mx-auto max-w-7xl px-4 py-10 sm:px-6" data-testid="admin-dashboard">
      <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="eyebrow">Painel do prestador</p>
          <h1 className="mt-2 text-3xl font-bold uppercase text-white sm:text-4xl">Olá, {user.name || "Nillo"}</h1>
        </div>
        <button onClick={logout} className="btn-line !py-2" data-testid="admin-logout-btn"><LogOut className="h-4 w-4" /> Sair</button>
      </div>
      <Tabs defaultValue="os">
        <TabsList className="mb-6 flex h-auto flex-wrap justify-start gap-1 rounded-none border border-slate-800 bg-[#111723] p-1">
          {TABS.map(([v, l]) => (
            <TabsTrigger key={v} value={v} data-testid={`admin-tab-${v}`} className="rounded-none font-heading text-xs font-bold uppercase tracking-wider text-slate-400 data-[state=active]:bg-[#DC2626] data-[state=active]:text-white">{l}</TabsTrigger>
          ))}
        </TabsList>
        {TABS.map(([v, , C]) => <TabsContent key={v} value={v}><C /></TabsContent>)}
      </Tabs>
    </section>
  );
}
